if (!customElements.get("product-option")) {
  class a extends HTMLElement {
    connectedCallback() {
      let t = this.querySelector(".product-option__label");
      
      this.querySelectorAll('input[type="radio"]').forEach((e) => {
        e.addEventListener("change", () => {
          this.setAttribute("data-value", e.value);
          this.dispatchEvent(new CustomEvent("valueChange"));
          if (t) {
            t.innerText = e.value;
          }
          this.updateRichtext(e.dataset.name, e.value);

          // Update fabric details buttons globally since the observer in product-form is broken for separated buttons
          if (this.querySelector('.product-option__swatch') || this.classList.contains('product-option--swatches')) {
            const handle = e.value.toLowerCase().trim().replace(/\s+/g, '-');
            document.querySelectorAll('.fab-details-btn').forEach(btn => {
              btn.setAttribute('data-handle', handle);
            });
          }
          this.updateFabricVideoTrigger(e);
        });
      });

      // Synchronize label on initialization in case JS already checked the radio before listeners were attached
      let checked = this.querySelector('input[type="radio"]:checked');
      if (checked) {
        if (t && t.innerText !== checked.value) {
          t.innerText = checked.value;
        }
        if (this.querySelector('.product-option__swatch') || this.classList.contains('product-option--swatches')) {
          const handle = checked.value.toLowerCase().trim().replace(/\s+/g, '-');
          document.querySelectorAll('.fab-details-btn').forEach(btn => {
            btn.setAttribute('data-handle', handle);
          });
        }
        this.updateFabricVideoTrigger(checked);
      }
    }
    updateFabricVideoTrigger(e) {
      const trigger = this.querySelector("[data-fabric-video-trigger]");
      if (!trigger) return;

      const src = e.dataset.fabricVideoSrc;
      const poster = e.dataset.fabricVideoPoster || "";
      const title = e.dataset.fabricVideoTitle || "";
      const preview = trigger.querySelector("img");

      if (!src) {
        trigger.hidden = true;
        trigger.removeAttribute("data-fabric-video-src");
        trigger.removeAttribute("data-fabric-video-poster");
        trigger.removeAttribute("data-fabric-video-title");
        return;
      }

      trigger.hidden = false;
      trigger.dataset.fabricVideoSrc = src;
      trigger.dataset.fabricVideoPoster = poster;
      trigger.dataset.fabricVideoTitle = title;
      trigger.setAttribute("title", title);

      if (preview && poster && preview.getAttribute("src") !== poster) {
        preview.setAttribute("src", poster);
        preview.setAttribute("alt", title);
      }
    }
    updateRichtext(e, t) {
      document.querySelectorAll(`.richtext [data-var="${e}"]`).forEach((e) => {
        e.innerHTML = t;
      });
    }
  }
  customElements.define("product-option", a);
}
